import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

interface UpdateTeacherInfoParams {
  teacherCode: string;
  bankAccount: string;
  bank: string;
  uid: string;
  address: string;
  isTaxPnd3: boolean;
}

export const useUpdateTeacherInfo = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ teacherCode, bankAccount, bank, uid, address, isTaxPnd3 }: UpdateTeacherInfoParams) => {
      // Update teacher_informations with upsert
      const { data, error } = await (supabase as any)
        .schema('teacher')
        .from('teacher_informations')
        .upsert(
          {
            code: teacherCode,
            bank_account: bankAccount,
            bank: bank,
            uid: uid,
            address: address,
          },
          { onConflict: 'code' }
        )
        .select()
        .maybeSingle();

      if (error) {
        throw error;
      }

      // Update is_tax_pnd3 on teacher.teachers
      const { error: teacherError } = await (supabase as any)
        .schema('teacher')
        .from('teachers')
        .update({ is_tax_pnd3: isTaxPnd3 })
        .eq('code', teacherCode);

      if (teacherError) {
        throw teacherError;
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['teacher-payroll'] });
      toast({
        title: 'บันทึกสำเร็จ',
        description: 'อัพเดทข้อมูลครูเรียบร้อยแล้ว',
      });
    },
    onError: (error: Error) => {
      toast({
        title: 'เกิดข้อผิดพลาด',
        description: error.message,
        variant: 'destructive',
      });
    },
  });
};
